import React, { createContext, useState, useEffect, useContext } from "react";

type RoleContextType = {
    userRole: string;
    refreshAuth: () => void;
};

const RoleContext = createContext<RoleContextType | null>(null);

export const RoleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [userRole, setUserRole] = useState('');

    const checkRole = () => {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const role = user.role;
        if (role) {
            setUserRole(role);
        }
    };

    useEffect(() => {
        checkRole(); // Run on mount
    }, []);

    return <RoleContext.Provider value={{ userRole, refreshAuth: checkRole }}>{children}</RoleContext.Provider>;
};

export const useRole = () => {
    const context = useContext(RoleContext);
    if (!context) throw new Error("useRole must be used within an RoleProvider");
    return context;
};
